import { Component, inject, OnInit } from '@angular/core';
import { dateField, userChipColumn } from '../../../../shared/components/kit/table/table.fields';
import { TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { FolderPalliativeCareObject } from '@libs/types/src/services/object-type/folder/folder-palliative-care.object';
import {
    PersonPalliativeCareDialogComponent,
} from './person-palliative-care-dialog/person-palliative-care-dialog.component';
import { PersonPalliativeCareStore } from './person-palliative-care.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TranslateService } from '@ngx-translate/core';
import { contentGlobalSuccess } from '../../../content.error';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';

@Component({
    selector: 'app-person-palliative-care',
    templateUrl: 'person-palliative-care.component.html',
    providers: [PersonPalliativeCareStore],
    imports: [
        TableComponent,
    ],
})
export class PersonPalliativeCareComponent implements OnInit {
    protected readonly dialogService = inject(BaseDialogService);
    protected readonly store = inject(PersonPalliativeCareStore);
    private readonly confirm = inject(ConfirmBuilder);
    private readonly translate = inject(TranslateService);


    protected readonly folderStore = inject(FolderGlobalStore);

    protected columns = [
        userChipColumn,
        dateField('dateFrom', false, false),
        dateField('dateTo', false, false),
        { name: 'note', type: TableColumnType.String50 },
    ];

    constructor() {
        const store = this.store;
        store.doOnActions(
            () => this.getCares(),
            'updateFolderPalliativeCare', 'createFolderPalliativeCare', 'deleteFolderPalliativeCare',
        );
    }

    public async ngOnInit() {
        await this.getCares();
    }

    openDialog(care?: FolderPalliativeCareObject | null) {
        this.dialogService.open(PersonPalliativeCareDialogComponent, {
            data: { care },
            header: this.translate.instant(care ? 'person.dashboard.palliativeCare.edit' : 'person.dashboard.palliativeCare.create'),
        });
    }

    protected detail(item: FolderPalliativeCareObject) {
        this.openDialog(item);
    }

    protected delete(event: any) {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteFolderPalliativeCare({ id: event.item.id });
                contentGlobalSuccess.next('common.deleted');
            },
            event,
        );
    }

    private async getCares(): Promise<void> {
        const folderId = this.store.folderId();
        if (!folderId) return;
        const filter = new FilterBuilder()
            .folderId(folderId)
            .limit(10)
            .sort('dateFrom');
        await this.store.api.getFolderPalliativeCares(filter.create());
    }
}
